module.exports = __webpack_public_path__ + "img/DSC_1156.9395c86c.jpg";